import React, { useCallback, useMemo, useState } from 'react';
import { Input, Tooltip, Button } from 'antd';
import { SearchProps } from 'antd/lib/input';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import SearchUploaderModal from './SearchUploaderModal';

const { Search } = Input;

interface ISearchUploader extends SearchProps {
  onUpload?: Function;
  columnName: string;
}

const SearchUploader = ({
  onUpload,
  columnName,
  ...inputProps
}: ISearchUploader) => {
  const { t } = useTranslation('inventory');
  const [modalVisible, setModalVisible] = useState(false);

  const suffix = useMemo(
    () => (
      <Tooltip title={t('file-search')}>
        <Button
          type="link"
          icon={<UploadOutlined />}
          size="small"
          style={{ height: 22, width: 22, alignItems: 'center' }}
          onClick={() => setModalVisible(true)}
        />
      </Tooltip>
    ),
    [t],
  );

  const setList = useCallback(
    (
      e: {
        [key: string]: string;
      }[],
    ) => {
      onUpload?.(e.map(item => Object.values(item)?.[0]));
    },
    [onUpload],
  );

  return (
    <>
      {inputProps?.onSearch ? (
        <Search suffix={suffix} allowClear {...inputProps} />
      ) : (
        <Input suffix={suffix} allowClear {...inputProps} />
      )}
      {modalVisible && (
        <SearchUploaderModal
          visible={modalVisible}
          onClose={() => setModalVisible(false)}
          columnName={columnName}
          setList={setList}
        />
      )}
    </>
  );
};

export default SearchUploader;
